module.exports = __webpack_public_path__ + "media/npc_dota_hero_marci.e8673bc7.webm";